import BaseClient from '@/app/model/api/response/baseApiClient'

class GetCamImgApi extends BaseClient {
  public getCamImgData (id: number, type: string) {
    const path = '/v1/file/cam-image/' + id
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({ 'type': type })

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }

  public doResponseConvert (response: any) {
    if (response.status === 200) {
      return response.blob()
    } else {
      throw Error(response.status)
    }
  }

  public getPayload (data: any) {
    const outside: any = URL.createObjectURL(data)
    return outside
  }
}

export default new GetCamImgApi()
